import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Plazos, PlazosResponse } from '@p-p-portafolio/promociones/interfaces/plazos';
import { Tasas } from '@p-p-portafolio/interfaces/tasas';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlazosService {

  private baseUrl = environment.apiBaseUrl + 'api/promociones/plazos';

  constructor(private http: HttpClient) { }

  form: UntypedFormGroup = new UntypedFormGroup({
    sPromocion: new UntypedFormControl(''),
    iPlazo: new UntypedFormControl(null, Validators.required),
    numVar: new UntypedFormControl(null)
  });

  initializeFormGroup() {
    this.form.setValue({
      sPromocion: '',
      iPlazo: null,
      numVar: null
    });
  }

  populateForm(entity: Plazos) {
    this.form.setValue(entity);
  }

  getAll(promocion : string){
    const url = `${this.baseUrl}/${promocion}/0`;
    return this.http.get<PlazosResponse[]>(url);
  }

  add(entity: Plazos) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    const url = `${this.baseUrl}/add`;
    return this.http.post<EntityOperationResult>(url, entity, httpOptions);
  }

  update(entity: Plazos) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    const url = `${this.baseUrl}/upd`;
    return this.http.put<EntityOperationResult>(url, entity, httpOptions);
  }


  delete(entity: Plazos, sPromocion: string) {
    const url = `${this.baseUrl}/del/${sPromocion}`;
    return this.http.delete<EntityOperationResult>(url, { body: entity })
  }
}
